<div class="admin-container" *ngIf="moduleName=='Admin'">

  <hr class="line" [ngStyle]="{ background: newColor }" />

  <app-topnav [pagename]="'SCRAII Admin Portal'"></app-topnav>

  <!-- <div class="eventCalender-container">
      <app-event-calendar></app-event-calendar>
  </div> -->
  <div style="overflow-y: auto;height: calc(100vh - 65px);height: calc(100dvh - 65px)">
    <div class="row mx-1 admin-layout-scrolls mt-3">
      <ng-container *ngFor="let page of pages">
        <div class="col-12 col-sm-12 col-md-6 col-lg-3 col-xl-3 mb-3">
          <mat-card class="card-container">
            <p class="du-admin-layout-name-header" [matTooltip]="page.admin_page_nm" matTooltipPosition="above">{{ page.admin_page_nm }}</p>
            <div class="du-admin-layout-image mt-2">
              <img mat-card-image class="du-admin-layout-mat-card-image"
                [src]="page.img_url"/>
            </div>
            
            <mat-card-actions>
              <div class="row">
                <div class="col-md-12 p-2">
                  <button mat-raised-button style="font-family: poppins !important;" [disabled]="page.access_flg != 'Y'"
                    [style.width.%]="100" color="primary" (click)="openPage(page)">
                    <span style="font-size: 16px;"> {{ 'Manage' }} </span>
                  </button>
                </div>
              </div>
            </mat-card-actions>
          </mat-card>
        </div>
      </ng-container>
    </div>
  </div>
</div>
